import remove from "../assets/cross-circle.svg";
import { useEffect } from "react";

const DepositModal = ({ credits, isVisible, onClose, onConfirm }) => {
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isVisible]);

  const handleClose = () => {
    if (onClose) {
      onClose(); // Ensure onClose is called correctly
    }
  };

  if (!isVisible) return null;

  const handleConfirm = () => {
    console.log("talleta clicked");
    onConfirm();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-xl shadow-lg p-6 w-1/3 max-h-[80vh] h-auto relative overflow-y-auto flex flex-col justify-center">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={handleClose}
        >
          <img src={remove} alt="close" className="w-6" />
        </button>
        <p className="mb-4">
          Viikko lisätty onnistuneesti. Haluatko tallettaa sen heti?
          Tallettamalla saat
          <span className="font-semibold ml-1">{credits}</span> lomakrediittiä.
        </p>
        <div className="flex justify-center">
          <button
            className="flex m-2 w-3/4 lg:w-1/2 justify-center rounded-3xl bg-teal-600 px-5 py-3 text-md lg:text-xl font-roboto leading-6 text-white shadow-sm hover:bg-teal-700 focus-visible:outline focus:bg-teal-700 focus-visible:outline-2 focus-visible:outline-offset-2"
            onClick={handleConfirm}
          >
            Talleta
          </button>
        </div>
      </div>
    </div>
  );
};

export default DepositModal;
